const base = "cui-hr-qrhy";
const classes = {
  base
};
export {
  base,
  classes as default
};
